import { ExportDataEntityEnum } from '../../../../shared/models';
import { PropertyTypeEnum } from '../../../../shared/properties';
import { generateViewColumnKeyFromMapping, ViewColumn } from '../../view';
import { checkViewColumnDefinition } from '../../view/check-view-column.definition';
import {
  ExportColumnDefinition,
  ExtractKeys,
} from './export-data-column.definition';

export const CHECK_EXPORT_DATA_COLUMN_KEYS = [
  'check_id',
  'check_status',
  'check_type',
  'check_entity_name',
  'check_entity_type',
  'check_last_activity_at',
  'check_is_internal',
  'check_reviewed_at',
  'check_reviewer_type',
  'check_review_comment',

  // AML fields
  'check_aml_true_positive_list_types',
  // Document fields
  'check_document_data_settings_document_type',
  // ID Document fields
  'check_id_document_vendor',
  // ID Verification fields
  'check_id_verification_vendor',
  'check_id_verification_mode',
  // Identity fields
  'check_identity_document_type',
  'check_identity_document_number',
  'check_identity_first_name',
  'check_identity_last_name',
  'check_identity_nationality',
  'check_identity_birth_date',
  'check_identity_birth_country',
  'check_identity_expiration_date',
  'check_identity_issuing_date',
  'check_identity_issuing_country',
  'check_created_at',
  'check_updated_at',
] as const;

// Type-safe keys type
export type CheckExportDataColumnKey = ExtractKeys<
  typeof CHECK_EXPORT_DATA_COLUMN_KEYS
>;

export const checkExportDataColumnDefinitionMap: Record<
  CheckExportDataColumnKey,
  ViewColumn<PropertyTypeEnum, PropertyTypeEnum>
> = {
  check_id: checkViewColumnDefinition.id,
  check_status: checkViewColumnDefinition.status,
  check_type: checkViewColumnDefinition.type,
  check_entity_name: checkViewColumnDefinition.entityName,
  check_entity_type: checkViewColumnDefinition.entityType,
  check_last_activity_at: checkViewColumnDefinition.lastActivityAt,
  check_is_internal: checkViewColumnDefinition.isInternal,
  check_reviewed_at: checkViewColumnDefinition.reviewedAt,
  check_reviewer_type: checkViewColumnDefinition.reviewerType,
  check_review_comment: checkViewColumnDefinition.reviewComment,
  // AML fields
  check_aml_true_positive_list_types:
    checkViewColumnDefinition.amlTruePositiveListTypes,
  // Document fields
  check_document_data_settings_document_type:
    checkViewColumnDefinition.documentDataSettingsDocumentType,
  // ID Document fields
  check_id_document_vendor: checkViewColumnDefinition.idDocumentVendor,
  // ID Verification fields
  check_id_verification_vendor: checkViewColumnDefinition.idVerificationVendor,
  check_id_verification_mode: checkViewColumnDefinition.idVerificationMode,
  // Identity fields
  check_identity_document_type: checkViewColumnDefinition.identityDocumentType,
  check_identity_document_number:
    checkViewColumnDefinition.identityDocumentNumber,
  check_identity_first_name: checkViewColumnDefinition.identityFirstName,
  check_identity_last_name: checkViewColumnDefinition.identityLastName,
  check_identity_nationality: checkViewColumnDefinition.identityNationality,
  check_identity_birth_date: checkViewColumnDefinition.identityBirthDate,
  check_identity_birth_country: checkViewColumnDefinition.identityBirthCountry,
  check_identity_expiration_date:
    checkViewColumnDefinition.identityExpirationDate,
  check_identity_issuing_date: checkViewColumnDefinition.identityIssuingDate,
  check_identity_issuing_country:
    checkViewColumnDefinition.identityIssuingCountry,
  check_created_at: checkViewColumnDefinition.createdAt,
  check_updated_at: checkViewColumnDefinition.updatedAt,
};

export const checkViewColumnKeyToExportColumnKey: Record<
  string,
  CheckExportDataColumnKey
> = Object.entries(checkExportDataColumnDefinitionMap).reduce(
  (acc, [key, { mapping }]) => {
    acc[generateViewColumnKeyFromMapping(mapping)] =
      key as CheckExportDataColumnKey;
    return acc;
  },
  {} as Record<string, CheckExportDataColumnKey>,
);

export const checkExportDataColumnDefinition: ExportColumnDefinition<CheckExportDataColumnKey>[] =
  CHECK_EXPORT_DATA_COLUMN_KEYS.map((checkColumnKey) => ({
    uniqueKey: checkColumnKey,
    sourceEntity: ExportDataEntityEnum.check,
    viewColumn: checkExportDataColumnDefinitionMap[checkColumnKey],
  }));
